import { lazyRoute } from "@/routes/lazy-route";

const PrioritySettingsPage = lazyRoute(() => import("./priority-settings.page"), "PrioritySettingsPage");

export const prioritySettingsRoutes = [
  {
    path: "priority",
    element: <PrioritySettingsPage />,
  },
];
